import React, { useMemo, useRef } from 'react';
import { FAQ as ToolBoxFAQ } from '@navi-toolbox/ui-components';
import { useSelector } from 'react-redux';

import { faqWrapper } from './styles';
import { getFaqVariables } from './ducks/selectors';
import { useIntersectionObserverCallback } from '@navi-toolbox/hooks';
import { analyticsUtils } from 'utils/analytics-utils';
import { getFAQ } from 'features/page-model';

export const FAQ = () => {
  const faqData = useSelector(getFAQ);
  const variables = useSelector(getFaqVariables);
  const ref = useRef<HTMLDivElement>(null);

  const showEventData = useMemo(
    () => ({
      elementType: 'block',
      elementBlock: 'productDetail',
      elementName: 'faq',
      elementText: faqData?.title,
    }),
    [faqData?.title],
  );

  useIntersectionObserverCallback(
    ref,
    {
      enter: () => {
        analyticsUtils.sendEvent('GA:show', showEventData);
      },
    },
    [],
  );

  const handleFaqClickCapture = (event: React.MouseEvent<HTMLDivElement>) => {
    const target = event.target as HTMLElement | null;
    if (!target) return;

    const button = target.closest('[role="button"][aria-label]');
    if (!button) return;

    if (button.getAttribute('aria-expanded') !== 'false') return;

    const question = button.getAttribute('aria-label');
    if (!question) return;

    analyticsUtils.sendEvent('GA:clickButton', {
      elementType: 'button',
      elementBlock: 'productDetail',
      elementName: 'faq',
      elementText: question,
    });
  };

  if (!faqData || faqData.data.length === 0) return null;

  return (
    <div className={faqWrapper} ref={ref} onClickCapture={handleFaqClickCapture}>
      <ToolBoxFAQ faq={faqData} variables={variables} />
    </div>
  );
};
